import { isEqual } from "lodash";
import { getActivePatchResult } from "./getActivePatchResult";
import { getVariantPatchContext } from "./getVariantPatchContext";
import { TlfContextProps } from "./interface";

/**
 * Recalculates the active patch error state after a patch-management operation.
 *
 * @param state - Current TLF context state
 * @returns State containing the current active-patch validation result
 */
export const updateActivePatchErrors = (state: TlfContextProps): TlfContextProps => {
  const result = getActivePatchResult(state, getVariantPatchContext(state));
  const invalidOps = result?.invalidOps ?? [];
  return isEqual(state.activeVariantPatchInvalidOps, invalidOps)
    ? state
    : { ...state, activeVariantPatchInvalidOps: invalidOps };
};
